import axios from "axios";

export const fetchGetQuestionsType = async () => {
  const baseTaskUrl = process.env.REACT_APP_TASK_API_URL;

  return await axios.get(`${baseTaskUrl}/QuestionType`);
};
